import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { SectionHeading } from "@/components/common/SectionHeading";
import { CtaButton } from "@/components/common/CtaButton";
// import { insights } from "@/data/insights.data";
import { articles } from "@/data/articles.data";
import { fadeUp, staggerContainer, viewportOnce } from "@/animations/motion";
import { ArrowUpRight, Clock } from "@/icons";
import { cn } from "@/lib/utils";

/** Insights — editorial blog cards with gradient covers (no stock imagery). */
export function Insights() {
  const featuredArticles = articles.filter(a => a.featured);  //added by sudip

  return (
    <Section id="insights">
      <Container>
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="Insights & Resources"
            title="Expert Insights on AI, Digital Transformation and Enterprise Technology"
            description="Explore practical articles, implementation guides and technology insights to help organisations modernise operations and make informed digital transformation decisions."
          />
          <CtaButton to="/insights" variant="outline" withArrow className="shrink-0">
            Read All Articles
          </CtaButton>
        </div>

        <motion.div
          variants={staggerContainer(0.08, 0.06)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-12 grid gap-6 md:grid-cols-3"
        >
          {/* modified by sudip from insights to featuredArticles */}
          {featuredArticles.map((post) => (
            <motion.article
              key={post.slug}
              variants={fadeUp}
              data-testid={`insight-card-${post.id}`}
              className="group flex flex-col overflow-hidden rounded-[1.25rem] border border-border bg-card transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(15,23,42,0.28)]"
            >
              <Link to={`/insights/${post.slug}`} className="flex flex-1 flex-col">
                {/* Gradient cover */}
                <div className="relative h-44 overflow-hidden">
                  <div
                    className={cn(
                      "absolute inset-0 bg-gradient-to-br transition-transform duration-700 group-hover:scale-105",
                      post.cover,
                    )}
                  />
                  <div className="absolute inset-0 bg-grid-light opacity-30" />
                  <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-secondary backdrop-blur">
                    {post.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-heading text-lg font-semibold text-foreground transition-colors group-hover:text-primary">
                    {post.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">
                    {post.excerpt}
                  </p>
                  <div className="mt-5 flex items-center justify-between text-xs text-muted-foreground">
                    <span className="inline-flex items-center gap-1.5">
                      <Clock className="h-3.5 w-3.5" /> {post.readingTime}
                    </span>
                    <span className="inline-flex items-center gap-1 font-medium text-primary">
                      Read Article<ArrowUpRight className="h-3.5 w-3.5" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </motion.div>
      </Container>
    </Section>
  );
}
